import { select, event } from "d3";
import { textactive } from "../../_helpers/_parametric_tools";
import { replaceCharacters } from "../../_helpers/_helpers";

export class Text {
  constructor(svg, svgAux = null, _this) {
    this.context = _this;
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
  }

  text({
    data,
    name,
    svgNode = "",
    svgNodeAux = "",
    xField = "date",
    yField = "y",
    textField = "text",
    fontSize = "12px",
    xOffset = 0,
    yOffset = 0,
    textAnchor = "middle",
    alignmentBaseline = "ideographic",
    rotate = 0,
    textColor = textactive(true),
    isYAxisNumber = true,
    formatText = null,
    yFields = null,
    index = null,
    yFieldsIncludes = null,
    positionText = "",
    maxHeight = 8,
  }) {
    const svg = svgNode ? svgNode : this.svg;
    const svgAux = svgNodeAux ? svgNodeAux : this.svgAux;
    const _this = this;

    const mouseOver = function(d) {
      event.preventDefault();
      const yPixels = Math.max(
        Math.min(event.layerY - svg.margin.top, svg.height),
        0,
      );
      // Showing elements
      for (let hoverElement of _this.context.hoverElements) {
        hoverElement.show({
          yPixels,
          selData: d,
          formatyInside: formatText,
          textField,
        });
      }
    };
    const mouseLeave = function() {
      // Hiding elements
      for (let hoverElement of _this.context.hoverElements) {
        hoverElement.hide();
      }
    };
    name = replaceCharacters(name);

    svg[name] = svgAux
      .selectAll("fa .text" + name)
      .data(data)
      .enter()
      .append("text")
      .attr("class", "text" + name)
      .filter(function(d) {
        if (Array.isArray(yField)) {
          for (let yF of yField) {
            return isYAxisNumber ? Number.isFinite(d[yF]) : true;
          }
        }
        return isYAxisNumber ? Number.isFinite(d[yField]) : true;
      })
      .attr("transform", function(d) {
        let accumulated = 0;

        if (yFields && yFieldsIncludes && positionText !== "bottom") {
          let positiveAccum = 0;
          let negativeAccum = 0;

          yFieldsIncludes
            .slice(0, index + 1)
            .filter((fieldName) => !Number.isNaN(d[fieldName]))
            .forEach((fieldName) => {
              const value = +d[fieldName];
              if (value >= 0) {
                if (index === yFieldsIncludes.indexOf(fieldName)) {
                  accumulated = svg.y(positiveAccum) - (value < 8 ? 0 : 5);
                }
                positiveAccum += value;
              } else {
                if (index === yFieldsIncludes.indexOf(fieldName)) {
                  accumulated =
                    svg.y(negativeAccum + value) + (value > -8 ? 0 : -5);
                }
                negativeAccum += value;
              }
            });
        } else if (positionText === "bottom") {
          accumulated = svg.y(d["zeroFld"]) + yOffset;
        } else {
          accumulated = svg.y(d[yField]) + yOffset;
        }

        return `translate(${svg.x(d[xField]) +
          Number(xOffset)}, ${accumulated}) rotate(${rotate})`;
      })
      .attr("x", 0)
      .style("fill", textColor)
      .style("text-anchor", textAnchor)
      .style("alignment-baseline", alignmentBaseline)
      .style("font-size", fontSize)
      .text(function(d) {
        let text;
        if (yFieldsIncludes) {
          const heightCurrentBar = _this.getHeightCurrentBar(
            d,
            yFieldsIncludes,
            index,
          );

          if (Array.isArray(yField)) {
            let customText = 0;
            for (let yF of yField) {
              customText += d[yF];
            }
            text = formatText ? formatText(customText) : customText;
          } else if (
            d[textField] === undefined ||
            (d[textField] < 0.01 && d[textField] > -0.01)
          ) {
            text = "";
          } else if (heightCurrentBar && heightCurrentBar < maxHeight) {
            this.classList.add("fa");
            text = "\uf141";
          } else {
            this.classList.remove("fa");
            text = formatText ? formatText(d[textField]) : d[textField];
          }
        } else {
          this.classList.remove("fa");
          text = formatText ? formatText(d[textField]) : d[textField];
        }
        return text;
      })
      .on("mouseover", function(d) {
        const heightCurrentBar = _this.getHeightCurrentBar(
          d,
          yFieldsIncludes,
          index,
        );
        if (heightCurrentBar < maxHeight) {
          mouseOver(d);
        }
      })
      .on("mousemove", function(d) {
        const heightCurrentBar = _this.getHeightCurrentBar(
          d,
          yFieldsIncludes,
          index,
        );
        if (heightCurrentBar < maxHeight) {
          mouseOver(d);
        }
      })
      .on("mouseout", mouseLeave);
  }

  getHeightCurrentBar(d, yFields, index) {
    let heightCurrentBarHeight;

    if (yFields) {
      const name = replaceCharacters(yFields[index]);
      const joinYField = name
        .split(" ")
        .join("")
        .replace("Perc", "");
      const currentBar = select(`.stackedBar${joinYField}${+d["date"]}`);
      const heightCurrentBar = currentBar.node();
      if (heightCurrentBar) {
        heightCurrentBarHeight = heightCurrentBar.getBoundingClientRect()
          .height;
      }
    }
    return heightCurrentBarHeight || 14;
  }
}
